import { Component } from '@angular/core';

@Component({
  selector: 'app-empty-layout',
  templateUrl: './empty-layout.component.html',
  styleUrl: './empty-layout.component.less'
})
export class EmptyLayoutComponent {

}
